/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface GetWidgetDataRequest
 */
export interface GetWidgetDataRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetWidgetDataRequest
     */
    keys: Array<string>;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetWidgetDataRequest
     */
    userId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof GetWidgetDataRequest
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {string}
     * @memberof GetWidgetDataRequest
     */
    role?: string | null;
}

/**
 * Check if a given object implements the GetWidgetDataRequest interface.
 */
export function instanceOfGetWidgetDataRequest(value: object): value is GetWidgetDataRequest {
    if (!('keys' in value) || value['keys'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    return true;
}

export function GetWidgetDataRequestFromJSON(json: any): GetWidgetDataRequest {
    return GetWidgetDataRequestFromJSONTyped(json, false);
}

export function GetWidgetDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetWidgetDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'keys': json['keys'],
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function GetWidgetDataRequestToJSON(json: any): GetWidgetDataRequest {
    return GetWidgetDataRequestToJSONTyped(json, false);
}

export function GetWidgetDataRequestToJSONTyped(value?: GetWidgetDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'keys': value['keys'],
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'role': value['role'],
    };
}

